module.exports = __webpack_public_path__ + "img/Ad_Redjinni.076d69a3.png";